import {avp, THREE} from "@adsk/lmv";

const _tmpBox = new THREE.Box3();

let _includeGhosted = false;
export function setIncludeGhosted(value) {
	_includeGhosted = value;
};

export function getIncludeGhosted() {
	return _includeGhosted;
}

const origIntersectFrustum = avp.RenderBatch.prototype.intersectFrustum;

avp.RenderBatch.prototype.intersectFrustum = function(frustumIntersector, callback, containmentKnown, includeGhosted = _includeGhosted) {

    if (!containmentKnown) {
        this.getBoundingBox(_tmpBox);
        if (includeGhosted) {
            const bboxHidden = this.getBoundingBoxHidden();
            _tmpBox.union(bboxHidden);
        }

        if (_tmpBox.isEmpty()) {
            // Don't do intersection if this batch's bbox is empty
            return;
        }

        let result = frustumIntersector.intersectsBox(_tmpBox);
        if (result === avp.FrustumIntersector.OUTSIDE) {
            return;
        }
        if (result === avp.FrustumIntersector.CONTAINS) {
            containmentKnown = true;
        }
    }

    // traverse all visible meshes
    this.forEach((m, fragId) => {

        // Don't intersect hidden objects
        if (this.frags.isFlagSet(fragId, avp.MeshFlags.MESH_HIDE))
            return;

        if (containmentKnown) {
            callback(fragId, containmentKnown);
            return;
        }

        // raycast worldBox first.
        this.frags.getWorldBounds(fragId, _tmpBox);

        let result = frustumIntersector.intersectsBox(_tmpBox);
        if (result !== avp.FrustumIntersector.OUTSIDE) {
            callback(fragId, result === avp.FrustumIntersector.CONTAINS);
        }
    }, includeGhosted ? 0 : avp.MeshFlags.MESH_VISIBLE);
}
